import { Button, Col, Form, Row, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { MdEdit } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { USER_PROFILE } from "@src/helpers/imagesConstants";
import Name from "../my-account-form/Name";
import Email from "../my-account-form/Email";
import Mobile from "../my-account-form/Mobile";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  changePassword,
  changePasswordClear,
  changePasswordRequest,
  getUserList,
  getUserListRequest,
  login,
  updateUser,
  updateUserRequest } from
"@src/redux";
import { retrieveItem } from "@src/helpers/functions";
import ChangePasswordModal from "../../change-password/ChangePasswordModel";
import {
  action,
  handleBeforeUpload,
  handleFileChanged,
  handleUpload } from
"@src/helpers/fileUpload";
import { useCheckPageComponentAccess } from "@src/hooks/index";
import toast from "react-hot-toast";

const ProfileDetails: React.FC = () => {
  const [form] = Form.useForm();
  const [profileForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const { t } = useTranslation();
  const [buttonVisible, setButtonVisible] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const userId = retrieveItem("userId");
  const { result: getUserListResult, loading: getUserListLoading } =
  useSelector(getUserList);
  const { result: updateUserResult, loading: updateUserLoading } =
  useSelector(updateUser);
  const { result: passwordChangeResult, loading: passwordChangeLoading } =
  useSelector(changePassword);
  const profile = Form.useWatch("profile", profileForm);

  const getUser = () => {
    dispatch(
      getUserListRequest({
        filter: {
          id: userId
        }
      })
    );
  };

  useEffect(() => {
    getUser();
  }, [dispatch]);

  useEffect(() => {
    if (updateUserResult?.status === "success") {
      setButtonVisible(false);
      getUser();
    }
  }, [updateUserResult]);

  useEffect(() => {
    if (passwordChangeResult?.status === "success") {
      setIsModalVisible(false);
      toast.success("Password changed successfully.");
      dispatch(changePasswordClear());
    } else if (passwordChangeResult?.error?.message) {
      toast.error(passwordChangeResult.error.message);
      dispatch(changePasswordClear());
    }
  }, [passwordChangeResult]);

  useEffect(() => {
    if (getUserListResult) {
      const user = getUserListResult.items?.[0];
      console.log("[ProfileDetails:getUserListResult]", getUserListResult);
      const countryCode = user?.mobile?.countryCode || user?.mobile?.CountryCode || "";
      const number = user?.mobile?.number || user?.mobile?.Number || "";
      const mobileNumber = `${countryCode}${number}`;

      form.setFieldsValue({
        name: user?.name,
        mobile: mobileNumber,
        email: user?.email
      });
    }
  }, [getUserListResult]);

  const onChangeEdit = () => {
    setButtonVisible(true);
  };

  const onClickCancel = () => {
    setButtonVisible(false);
  };

  const onFinish = (values: any) => {
    let mobile = values.mobile.split("").slice(3).join("");
    let country_code = values.mobile.split("").slice(0, 3).join("");

    dispatch(
      updateUserRequest({
        id: userId,
        data: {
          email: values.email,
          name: values.name,
          photo: profile?.file?.url || getUserListResult?.items?.[0]?.photo,
          mobile: {
            number: mobile,
            countryCode: country_code
          }
        }
      })
    );
  };
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    passwordForm.resetFields();
  };

  const handlePasswordChange = (passwordValues: any) => {
    dispatch(
      changePasswordRequest({
        data: {
          oldPassword: passwordValues.oldPassword,
          newPassword: passwordValues.new_password,
          userId: userId
        }
      })
    );
  };

  if (getUserListLoading && !getUserListResult?.items?.length) {
    return (
      <div className="my-acc-profile-container">
        <div className="inline-loading-wrap">
          <div className="inline-loading-spinner" />
          <div className="inline-loading-text">
            {t("loading_profile") || "Loading profile..."}
          </div>
        </div>
      </div>);

  }

  return (
    <div className="my-acc-profile-container">
      <Row className="form-container">
        <Col span={10} className="avatar-container">
          <Form form={profileForm}>
            <Form.Item name={"profile"}>
              <Upload
                action={action}
                customRequest={(e) => handleUpload(e)}
                beforeUpload={(args) => handleBeforeUpload(args, "profile", ['image/jpeg', "image/jpg", "image/png"])}
                onChange={(e) => handleFileChanged(e)}
                showUploadList={false}
                // disabled={!buttonVisible}
              >
                <div className="user-profile-wrapper">
                  <img
                    src={
                    profile?.file?.url ||
                    getUserListResult?.items?.[0]?.photo ||
                    USER_PROFILE}

                    className="user_profile_image"
                    alt="User Profile" />
                  

                  {buttonVisible && <MdEdit className="edit-icon" />}
                </div>
              </Upload>
            </Form.Item>
          </Form>
        </Col>
        <Col span={10}>
          <Form
            layout="horizontal"
            className="profile-form"
            form={form}
            onFinish={onFinish}
            labelCol={{
              flex: "110px"
            }}
            labelAlign="left"
            labelWrap
            wrapperCol={{
              flex: 1
            }}
            colon={false}>
            
            <Name visible={buttonVisible} />
            <Mobile visible={buttonVisible} />
            <Email visible={buttonVisible} />
            {!buttonVisible ?
            <div className="my_account_button_wrapper">
                <Button
                type="default"
                className="change-btn"
                htmlType="button"
                onClick={handleOpenModal}>

                    {t("change_password")}
                  </Button>

                {useCheckPageComponentAccess("edit_profile_button") &&
              <Button
                className="my_account_edit_button"
                onClick={onChangeEdit}
                disabled={false}
                htmlType="button">

                    {t("act_edit")}
                  </Button>}

              </div> :

            <div className="my_account_button_wrapper">
                <Form.Item>
                  <Button
                  type="default"
                  className="cancel-btn"
                  onClick={onClickCancel}>
                  
                    {t("cancel")}
                  </Button>
                  <Button
                  type="primary"
                  htmlType="submit"
                  loading={updateUserLoading}>
                  
                    {t("submit")}
                  </Button>
                </Form.Item>
              </div>}
            
          </Form>
        </Col>
      </Row>
      <ChangePasswordModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        onSubmit={handlePasswordChange}
        form={passwordForm} />
      
    </div>);

};

export default ProfileDetails;